import PropTypes from "prop-types";
import clsx from "clsx";
import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const Logo = ({ imageUrl, logoClass }) => {
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  
  // Redux 상태에서 로그인 상태와 withcookieData 가져오기
  const { isUserLoggedIn } = useSelector((state) => state.withcookie);
  const withcookieData = useSelector(state => state.withcookie?.withcookieData);
  
  // companyId 가져오기
  const companyId = withcookieData?.skin?.companyId;
  
  // companySettingJson에서 로고 URL 설정 추출
  let logoUrlLogged = "/";  // 최소 기본값
  let logoUrlNonLogged = "/";  // 최소 기본값
  
  // 파싱된 설정 객체
  let parsedSettings = null;
  
  try {
    const settingJson = withcookieData?.skin?.company?.companySettingJson;
    
    // 문자열인 경우 JSON 파싱
    if (typeof settingJson === 'string' && settingJson) {
      try {
        parsedSettings = JSON.parse(settingJson);
    
        
        if (parsedSettings.logo_url_logged) {
          logoUrlLogged = parsedSettings.logo_url_logged;
        }
        
        if (parsedSettings.logo_url_nonlogged) {
          logoUrlNonLogged = parsedSettings.logo_url_nonlogged;
        }
      } catch (e) {
        console.error('[로고] JSON 파싱 오류:', e);
      }
    } else if (typeof settingJson === 'object' && settingJson !== null) {
      // 이미 객체인 경우
      parsedSettings = settingJson;

      
      if (parsedSettings.logo_url_logged) {
        logoUrlLogged = parsedSettings.logo_url_logged;
      }
      
      if (parsedSettings.logo_url_nonlogged) {
        logoUrlNonLogged = parsedSettings.logo_url_nonlogged;
      }
    }
  } catch (error) {
    console.error("[로고] 설정 처리 오류:", error);
  }

  
  // 현재 로그인 상태에 따라 사용할 URL 결정
  const targetLogoUrl = isUserLoggedIn ? logoUrlLogged : logoUrlNonLogged;
  
  // 경로 정규화 함수 - 시작과 끝의 슬래시 제거
  const normalizePath = (path) => {
    if (!path) return "";
    return path.replace(/^\/+|\/+$/g, '');
  };
  
  // 현재 경로와 대상 URL 정규화
  const currentPathname = normalizePath(location.pathname);
  const targetPathname = normalizePath(targetLogoUrl);
  

  
  // 경로가 일치하는지 확인
  const isPathMatch = currentPathname === targetPathname;
  
  // 로고 클릭 핸들러
  const handleLogoClick = () => {
    if (!isPathMatch) {
      navigate(targetLogoUrl);
    }
  };

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 767);
    };
    
    checkMobile();
    window.addEventListener("resize", checkMobile);
    
    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);
  
  // 이미지 스타일
  const imgStyle = {
    maxWidth: "100%",
    objectFit: "contain",
    padding: "10px",
    margin: 0,
    maxHeight: isMobile ? "70px" : "90px",
    display: "inline-block",
    verticalAlign: "middle",
    marginTop: "5px"
  };

  // companyId가 22인 경우 강제 스타일
  const companySpecificStyle = companyId === 22 ? {
    ...imgStyle,
    maxWidth: "150px",
    paddingTop: "15px",
    padding: "15px 10px 10px 10px" // paddingTop을 우선 적용
  } : imgStyle;

  return (
    <div className={clsx(logoClass)} style={{ 
      padding: 0, 
      display: "flex", alignItems: "center", height: "100%", marginTop: "-8px" 
    }}>
      <div 
        onClick={handleLogoClick}
        style={{ 
          padding: 0, 
          cursor: isPathMatch ? 'default' : 'pointer'
        }}
      >
        <img 
          alt="" 
          src={imageUrl.startsWith("http") ? imageUrl : process.env.PUBLIC_URL + imageUrl} 
          onError={(e) => {
            console.error("로고 이미지 로드 오류");
            e.target.src = process.env.PUBLIC_URL + "/assets_flone/img/logo/logo.png";
          }}
          style={companySpecificStyle}
        />
      </div>
    </div>
  );
};

Logo.propTypes = {
  imageUrl: PropTypes.string,
  logoClass: PropTypes.string
};

export default Logo;
